/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerReprocessRunActionsMutationResponse, TriggerReprocessRunActionsPathParams, TriggerReprocessRunActions400, TriggerReprocessRunActions404 } from "../models/TriggerReprocessRunActions";

export function getTriggerReprocessRunActionsUrl(id: TriggerReprocessRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/aod-runs/${id}/reprocess` as const }
  return res
}

/**
 * @description Triggers a reprocess of the order associated with a run using the Olaf API
 * @summary Trigger Olaf reprocess for a run
 * {@link /aod-runs/:id/reprocess}
 */
export async function triggerReprocessRunActions(id: TriggerReprocessRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<TriggerReprocessRunActionsMutationResponse, ResponseErrorConfig<TriggerReprocessRunActions400 | TriggerReprocessRunActions404>, unknown>({ method : "PUT", url : getTriggerReprocessRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}